import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  sidebarLoading: false,
  sidebarError: null,
  sidebarLinks: [],

  dashboardRender:false,
  dashboardLoading: false,
  dashboardError: null,
  dashboardData: [],

  listViewTabData: {},
  listViewLoading: false,
  listViewError: null,

  notifications: [],
  notificationsMeta: [],
  notificationsLoading: false,
  notificationsError: null,

  dashletDialogLoading: false,
  dashletDialogError: null,
  dashletDialogData: [],

  removeDashletLoading: false,
  removeDashletError: null,

  removeDashboard:null,

  dashletLoading: false,
  dashletError: null,
  dashletData: [],

  addDashletLoading: false,
  addDashletError: null,
  addedDashlet: [],

  editDashletLoading: false,
  editDashletError: null,
  editDashletData: [],

  configureDashletLoading: false,
  configureDashletError: null,
  configureDashletData: [],

  addDashboardLoading: false,
  addDashboardError: null,

  saveLayoutLoading: false,
  saveLayoutError: null,

  storeStateLoading: false,
  storeStateError: null,
  storeStateData: [],

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Sidebar links reducer cases
    case actionTypes.SIDEBAR_LINKS_REQUEST:
      return { ...state, sidebarLoading: true };

    case actionTypes.SIDEBAR_LINKS_SUCCESS:
      return {
        ...state,
        sidebarLoading: false,
        sidebarLinks: action.payload,
      };

    case actionTypes.SIDEBAR_LINKS_FAILURE:
      return {
        ...state,
        sidebarLoading: false,
        sidebarError: action.error,
      };

    case actionTypes.DASHBOARD_REQUEST:
      return { ...state, dashboardLoading: true,dashboardRender:false };

    case actionTypes.DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardLoading: false,
        dashboardRender:true,
        dashboardData: {
          ...state.dashboardData,
          [action.tab]: action.payload,
        },
        storeStateData:[]
      };

    case actionTypes.DASHBOARD_FAILURE:
      return {
        ...state,
        dashboardRender:false,
        dashboardLoading: false,
        dashboardError: action.error,
      };

    case actionTypes.GET_DASHLET_REQUEST:
      return { ...state, dashletLoading: { [action.dash]: true } };

    case actionTypes.GET_DASHLET_SUCCESS:
      return {
        ...state,
        dashletLoading: false,
        dashletData: {
          ...state.dashletData,
          [action.dash]: action.payload,
        },
      };

    case actionTypes.GET_DASHLET_FAILURE:
      return {
        ...state,
        dashletLoading: false,
        dashletError: action.error,
      };

    case actionTypes.GET_NOTIFICATIONS_REQUEST:
      return { ...state, notificationsLoading: true };

    case actionTypes.GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload.data,
        notificationsMeta: action.payload.meta,
        notificationsLoading: false,
        notificationsError: null,
      };

    case actionTypes.GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notificationsLoading: false,
        notificationsError: action.error,
      };

    case actionTypes.MARK_NOTIFICATION_READ_SUCCESS:
      let filteredNotifications = state.notifications.data.filter(
        (notification) => notification.id !== action.id,
      );
      return {
        ...state,
        notifications: filteredNotifications,
      };

    // DashletDialog links reducer cases
    case actionTypes.DASHLET_DIALOG_LINKS_REQUEST:
      return { ...state, dashletDialogLoading: true };

    case actionTypes.DASHLET_DIALOG_LINKS_SUCCESS:
      return {
        ...state,
        dashletDialogLoading: false,
        dashletDialogData: action.payload,
      };

    case actionTypes.DASHLET_DIALOG_LINKS_FAILURE:
      return {
        ...state,
        dashletDialogLoading: false,
        dashletDialogError: action.error,
      };

    // Remove dashlet reducer cases
    case actionTypes.REMOVEDASHLET_REQUEST:
      return { ...state, removeDashletLoading: true };
    case actionTypes.REMOVEDASHLET_SUCCESS:
      return {
        ...state,
        removeDashletLoading: false,
      };
    case actionTypes.REMOVEDASHBOARD_SUCCESS:
    return {
      ...state,
      removeDashboard: true,
    };
    case actionTypes.REMOVEDASHLET_FAILURE:
      return {
        ...state,
        removeDashletLoading: false,
        removeDashletError: action.error,
      };



    // Add dashlet reducer cases
    case actionTypes.ADD_DASHLET_REQUEST:
      return { ...state, addDashletLoading: true };
    case actionTypes.ADD_DASHLET_SUCCESS:
      return {
        ...state,
        addDashletLoading: false,
        addedDashlet: action.payload,
      };

    case actionTypes.ADD_DASHLET_FAILURE:
      return {
        ...state,
        addDashletLoading: false,
        addDashletError: action.error,
      };

    // Edit dashlet reducer 
    case actionTypes.EDIT_DASHLET_REQUEST:
      return { ...state, editDashletLoading: true };
    case actionTypes.EDIT_DASHLET_SUCCESS:
      return {
        ...state,
        editDashletLoading: false,
        editDashletData: action.payload,
       

      };

    case actionTypes.EDIT_DASHLET_FAILURE:
      return {
        ...state,
        editDashletLoading: false,
        editDashletError: action.error,
      };

    // Congirue dashlet reducer 
    case actionTypes.CONFIGURE_DASHLET_REQUEST:
      return { ...state, configureDashletLoading: true };
    case actionTypes.CONFIGURE_DASHLET_SUCCESS:
      return {
        ...state,
        configureDashletLoading: false,
        configureDashletData: action.payload,
        storeStateData:[]
      };

       // Congirue dashlet reducer 
    case actionTypes.STORE_STATE_REQUEST:
      return { ...state, storeStateLoading: true };
    case actionTypes.STORE_STATE_SUCCESS:
      return {
        ...state,
        storeStateLoading: false,
        storeStateData: {
          ...state.storeStateData,
          [action.payload[0]]: action.payload[1],
        },
      };

    case actionTypes.CONFIGURE_DASHLET_FAILURE:
      return {
        ...state,
        configureDashletLoading: false,
        congigureDashletError: action.error,
      };


    // Add dashboard reducer cases
    case actionTypes.ADD_DASHBOARD_REQUEST:
      return { ...state, addDashboardLoading: true };
    case actionTypes.ADD_DASHBOARD_SUCCESS:
      return {
        ...state,
        addDashboardLoading: false,
      };

    case actionTypes.ADD_DASHBOARD_FAILURE:
      return {
        ...state,
        addDashboardLoading: false,
        addDashboardError: action.error,
      };

    // Save dashlet layout reducer cases
    case actionTypes.SAVE_DASHLET_LAYOUT_REQUEST:
      return { ...state, saveLayoutLoading: true };
    case actionTypes.SAVE_DASHLET_LAYOUT_SUCCESS:
      return {
        ...state,
        saveLayoutLoading: false,
      };

    case actionTypes.SAVE_DASHLET_LAYOUT_FAILURE:
      return {
        ...state,
        saveLayoutLoading: false,
        saveLayoutError: action.error,
      };

    default:
      return state;
  }
};